exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-14[data-v-1d61d1c5] {\n    font-size: 14px;\n}\n.accepting[data-v-1d61d1c5] {\n    color: #38dab4;\n}\n.col-white[data-v-1d61d1c5] {\n    color: white;\n}\n.btn-accepting-orders[data-v-1d61d1c5] {\n    /* width: 30px; */\n    line-height: 12px;\n    background-color: transparent;\n}\n#header-main-text[data-v-1d61d1c5] {\n    color: whitesmoke\n}\n.header-name[data-v-1d61d1c5] {\n    font-size: 16px;\n    color: whitesmoke;\n}\n.btn-logout[data-v-1d61d1c5] {\n    width: 120px;\n}\n", ""]);

// exports
